const URL = "https://api.classplusapp.com";

const getIpURL = () => {
  return `${URL}/v3/countryData/ip`;
};

export const IpURL = getIpURL();
